export const SECTIONS = {
  HOME: "home",
  DESK: "desk",
  HOBBIES: "hobbies",
  EXPERIENCE: "experience",
  PROJECTS: "projects",
  LIBRARY: "library",
};
